export default __webpack_public_path__ + "static/media/bpaisley.bb77e407.jpg";